(() => {
  const SELECTOR = '[data-hoi-reviews]';

  function init(root) {
    if (!root || root.dataset.hoiReviewsReady === 'true') return;
    root.dataset.hoiReviewsReady = 'true';

    const openButton = root.querySelector('[data-hoi-reviews-open]');
    const layer = root.querySelector('[data-hoi-reviews-layer]');
    const modal = root.querySelector('[role="dialog"]');
    const grid = root.querySelector('[data-hoi-reviews-grid]');
    const sort = root.querySelector('[data-hoi-reviews-sort]');
    if (!openButton || !layer || !modal) return;

    let lastFocus = null;
    let measuredTruncation = false;
    const focusableSelector = 'a[href],button:not([disabled]),select:not([disabled]),textarea:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';

    const measureReviewTruncation = () => {
      if (measuredTruncation) return;
      measuredTruncation = true;
      const items = [];
      root.querySelectorAll('[data-hoi-review-text]').forEach((text) => {
        const button = text.parentElement.querySelector('[data-hoi-review-more]');
        if (button) items.push({ text, button, truncated: text.scrollHeight > text.clientHeight + 2 });
      });
      items.forEach(({ button, truncated }) => {
        if (truncated) button.hidden = false;
      });
    };

    const open = () => {
      lastFocus = document.activeElement;
      layer.hidden = false;
      document.body.classList.add('hoi-reviews-open');
      openButton.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        measureReviewTruncation();
        modal.focus();
      });
    };

    const close = () => {
      layer.hidden = true;
      document.body.classList.remove('hoi-reviews-open');
      openButton.setAttribute('aria-expanded', 'false');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    openButton.addEventListener('click', open);
    root.querySelectorAll('[data-hoi-reviews-close]').forEach((el) => el.addEventListener('click', close));

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll(focusableSelector)].filter((el) => el.offsetParent !== null);
      if (!focusable.length) {
        event.preventDefault();
        modal.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    root.querySelectorAll('[data-hoi-review-text]').forEach((text) => {
      const button = text.parentElement.querySelector('[data-hoi-review-more]');
      if (!button) return;
      button.addEventListener('click', () => {
        const expanded = text.classList.toggle('is-expanded');
        button.textContent = expanded ? 'See less' : 'See more';
      });
    });

    if (sort && grid) {
      const originalCards = [...grid.querySelectorAll('[data-hoi-review-card]')];
      sort.addEventListener('change', () => {
        let cards = [...originalCards];
        if (sort.value === 'highest') cards.sort((a, b) => Number(b.dataset.rating) - Number(a.dataset.rating));
        if (sort.value === 'lowest') cards.sort((a, b) => Number(a.dataset.rating) - Number(b.dataset.rating));
        if (sort.value === 'recent') cards.sort((a, b) => {
          const bd = Date.parse(b.dataset.date || '') || 0;
          const ad = Date.parse(a.dataset.date || '') || 0;
          return bd - ad;
        });
        if (sort.value === 'media') cards = cards.filter((card) => card.dataset.media === 'true');
        grid.replaceChildren(...cards);
      });
    }
  }

  const initAll = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
